//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    countryName: {
      type: String,
      default: null
    },
    flag: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    bottomText: {
      type: String,
      default: null
    }
  }
}
